export enum RATE_TYPE {
  market = 'market',
  prebooked = 'prebook',
}

export interface IRate {
  rate: number;
  conversionFeeRate: number;
}

export interface IRateResponse {
  success: boolean;
  data?: IRate;
  error?: string;
}

export interface IForwardRateAndFees extends IRate {
  ccyPair: string;
  fwdDate: string;
  fwdDateAdjusted: string;
  spotRate: number;
  flexFeeRate: number;
  bookingFeeRate: number;
  debug?: any;
}

export interface IForwardRateAndFeesResponse {
  success: boolean;
  data?: IForwardRateAndFees;
  error?: string;
}

interface CurrencyRateValues {
  currencyCode: string;
  rate: number | undefined;
}

export type CurrencyRate = PromiseSettledResult<CurrencyRateValues>;

export type CurrencyRateFulfilled = PromiseFulfilledResult<CurrencyRateValues>;
